import { createGlobalStyle } from '@lessonnine/design-system.lib';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';
// External Imports
import React from 'react';
import Helmet from 'react-helmet';

// Local Variables
const getBackgroundColor = (color) => color.neutral.surfaceDefault;

const GlobalBackgroundColorStyle = createGlobalStyle`
  html, body {
    background-color: ${({ theme }) => getBackgroundColor(theme.color)};
  }
`;

function BackgroundColor() {
  return (
    <>
      <Helmet>
        <meta content={getBackgroundColor(tokens.color.theme.light)} name="theme-color" />
        <meta
          content={getBackgroundColor(tokens.color.theme.dark)}
          media="(prefers-color-scheme: dark)"
          name="theme-color"
        />
      </Helmet>
      <GlobalBackgroundColorStyle />
    </>
  );
}

// Module Exports
export { BackgroundColor };
